import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryItem } from 'app/app-model/category-item';
import { CategoryName } from 'app/app-model/enums';
import { FlashModel } from 'app/app-model/flash/flash.model';
import { FlashService } from 'app/app-services/flash.service';
import { SpecificationService } from 'app/app-services/specification-service';
import { PropertyType } from 'app/modules/shared/model/properties/base-property';
import { ServiceExecutionSequence } from 'app/modules/shared/model/service-execution/service-execution-sequence';
import { Subscription } from 'rxjs';

export class FlashCategoryItem extends CategoryItem {

  flashService: FlashService;
  propertyType: PropertyType = PropertyType.Both;
  oldName = '';
  private serviceExecutionModifiedSubscription: Subscription;

  private _model: FlashModel;
  public get model(): FlashModel {
    return this._model;
  }
  public set model(v: FlashModel) {
    this._model = v;
    this.syncFromModel();
  }

  private _serviceExecutionSequence: ServiceExecutionSequence;
  public get serviceExecutionSequence(): ServiceExecutionSequence {
    return this._serviceExecutionSequence;
  }

  public set serviceExecutionSequence(v: ServiceExecutionSequence) {
    this._serviceExecutionSequence = v;
  }

  constructor(private specificationService: SpecificationService,
    private locationService: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    super();
    this._serviceExecutionSequence = new ServiceExecutionSequence();
    this.categoryType = CategoryName.Flash;
  }

  setName(name: string) {
    this.oldName = this.model.name;
    this.name = name;
    this.model.name = name;
    this.notifyFlashChanged();
  }

  setSecurityAccessMode(securityAccessModeName: string | null) {
    this.model.securityAccessModeName = securityAccessModeName;
    this.notifyFlashChanged();
  }

  notifyFlashChanged() {
    console.log('Flash ' + this.name + ' modified...Saving changes');
    this.flashService.updateItem(this.specificationService.currentSpecificationVersion.id, this.model, this.oldName)
      .subscribe({
        next: updatedFlash => {
          this.model = updatedFlash;

          const newUrl = this.router.createUrlTree([], {
            relativeTo: this.activatedRoute,
            queryParams: { itemId: this.model.name }
          }).toString();
          this.locationService.go(newUrl);

          console.log('Flash' + this.name + ' successfully updated');
        },
        error: err => console.error('Failed to update Flash in dcode api:', err)
      });
  }

  private syncFromModel() {
    this.name = this.model.name;
    this.oldName = this.name;

    if (!this.isPreview && this.model.setSequence) {
      this.serviceExecutionSequence.diagnosticServiceProvider = this.diagnosticServiceProvider;
      this.serviceExecutionSequence.specificationVersionId = this.specificationService.currentSpecificationVersion.id;
      this.serviceExecutionSequence.setModel(this.model.setSequence).subscribe({
        next: () => {
          this.subscribeServiceExecutionModifiedEvents();
          super.specificationVersionId = this.specificationService.currentSpecificationVersion.id;
        },
        error: err => console.error('Failed to initialize Flash in dcode api:', err)
      });
    }
  }

  private subscribeServiceExecutionModifiedEvents() {
    if (!this.hasModificationSubscriptions) {
      this.serviceExecutionModifiedSubscription = this._serviceExecutionSequence.modified.subscribe({
        next: () => this.notifyFlashChanged()
      });

      this.hasModificationSubscriptions = true;
    }
  }

  destroy() {
    if (this.serviceExecutionModifiedSubscription) {
      this.serviceExecutionModifiedSubscription.unsubscribe();
      this.serviceExecutionModifiedSubscription = undefined;
    }

    this.hasModificationSubscriptions = false;
  }
}
